import type { AuthContext } from '@/context';
import type { APIDispatch } from '@/hooks/api';

export function shouldLoad(loaded: boolean, force: boolean, auth: AuthContext) {
  return (!loaded || force) && auth?.firebaseUser;
}

export async function apiInvoke<R>(
  api: APIDispatch,
  url: string,
  auth: AuthContext,
  init?: RequestInit,
): Promise<R> {
  const res = await api(url, auth.firebaseUser || null, init || {});
  const contentType = res.headers.get('Content-Type');
  if (
    contentType !== 'application/json' &&
    !contentType?.startsWith('application/json;')
  ) {
    const txt = await res.text();

    return txt as R;
  }

  const obj = await res.json();

  return obj as R;
}
